export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CustomerPackage.vue?vue&type=template&id=357ab95a&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/extranet/CustomerPackage.vue?vue&type=template&id=357ab95a&scoped=true
// module id = 2106
// module chunks = 31